module.exports = __webpack_public_path__ + "img/20240920072210465wmp.5747f3ed.jpg";